import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import React from 'react';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
// import {CommunityTabRoutes} from 'src/modules/community/communityTabRoutes';
import { renderAdminTabRoutes } from 'src/modules/admin/adminTabRoutes';
import useIsSuperAdmin from 'src/modules/authentication/hooks/useIsSuperAdmin';
import useUserStorage from 'src/modules/authentication/storage/user/hook';
import { isRegisteredUser } from 'src/modules/authentication/storage/user/utils';
import { renderDebugTabRoutes } from 'src/modules/debug/debugTabRoutes';
import { renderExamPreparationTabRoutes } from 'src/modules/exam-preparation/examPreparationTabRoutes';
import useUnreadNotificationBgFetcher from 'src/modules/notification/hooks/useUnreadNotificationBgFetcher';
import useUnreadNotificationCount from 'src/modules/notification/hooks/useUnreadNotificationCount';
import { renderNotificationTabRoutes } from 'src/modules/notification/notificationTabRoutes';
import { renderSTCTabRoutes } from 'src/modules/support-the-creators/stcTabRoutes';
import useI18n from 'src/modules/translations/hooks/useI18n';
import { renderUserTabRoutes } from 'src/modules/user/userTabRoutes';
import { InitialRouteName } from './config';
import { RootStack } from './RootNavigation';
export const RootTab = createBottomTabNavigator();
const TabNavigator = () => {
    const [{ theme, deviceType, dimensions }] = useTheme(stylesGenerator);
    const { translate } = useI18n();
    useUnreadNotificationBgFetcher();
    const isSuperAdmin = useIsSuperAdmin();
    const [userDetails] = useUserStorage();
    const isRegistered = isRegisteredUser(userDetails);
    const [unreadCountState] = useUnreadNotificationCount();
    const routeRenderProps = { translate };
    return (React.createElement(RootTab.Navigator, { screenOptions: {
            headerShown: false,
            tabBarActiveTintColor: theme.palette.primary.dark,
            tabBarInactiveTintColor: theme.palette.typography.primary,
            tabBarStyle: {
                backgroundColor: theme.palette.background.main,
                paddingBottom: dimensions.safeAreaInsets.bottom,
                height: 48 + dimensions.safeAreaInsets.bottom,
            },
            tabBarAllowFontScaling: true,
            tabBarHideOnKeyboard: true,
            tabBarShowLabel: !deviceType.isPhone,
        }, initialRouteName: InitialRouteName },
        renderExamPreparationTabRoutes(routeRenderProps),
        renderNotificationTabRoutes({
            ...routeRenderProps,
            isRegistered,
            unreadCount: unreadCountState.count,
        }),
        renderUserTabRoutes(routeRenderProps),
        renderSTCTabRoutes(routeRenderProps),
        isSuperAdmin && renderAdminTabRoutes(routeRenderProps),
        __DEV__ && renderDebugTabRoutes(routeRenderProps)));
};
export const stylesGenerator = createThemedStyle(() => ({
    drawerItem: {
        marginHorizontal: 0,
        marginVertical: 0,
        borderRadius: 0,
        paddingVertical: 4,
    },
}));
export const renderTabStackRoutes = ({}) => {
    return (React.createElement(RootStack.Screen, { name: "Tabs", component: TabNavigator }));
};
